import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({
  name: 'BillKeysUpdate',
  standalone: true,
})
export class BillKeysUpdatePipe implements PipeTransform {

  transform(value: string): string {
    switch(value) {
      case 'periodo_inicio':
        return 'Periodo Inicio';
      case 'quantity':
        return 'Cantidad';
      case 'price':
        return 'P. U.';
      case 'discount_amount':
        return 'Dto.';
      default:
        return value;
    }
  }
}
